// src/services/FaceApiLoader.js
import * as faceapi from 'face-api.js';

class FaceApiLoader {
  constructor() {
    this.modelsLoaded = false;
    this.loading = false;
    this.progress = 0;
    this.totalModels = 2; // tinyFaceDetector + faceLandmark68Net
    this.loadedModels = 0;
    this.listeners = [];
    this.modelPath = '/models';
  }

  /**
   * Inicia o carregamento dos modelos
   */
  async loadModels() {
    if (this.modelsLoaded) {
      this.progress = 100;
      return Promise.resolve();
    }

    if (this.loading) {
      return new Promise(resolve => this.listeners.push(resolve));
    }

    this.loading = true;
    this.progress = 0;
    this.loadedModels = 0;

    const loadTiny = faceapi.nets.tinyFaceDetector.loadFromUri(this.modelPath);
    const loadLandmarks = faceapi.nets.faceLandmark68Net.loadFromUri(this.modelPath);
    // const loadFaceRecognition = faceapi.nets.faceRecognitionNet.loadFromUri(this.modelPath); // opcional
    
    const updateProgress = () => {
      this.loadedModels++;
      this.progress = Math.round((this.loadedModels / this.totalModels) * 100);
      this.notifyListeners();
    };

    try {
      await Promise.all([
        loadTiny.then(() => updateProgress()),
        loadLandmarks.then(() => updateProgress())
        // loadFaceRecognition.then(() => updateProgress())
      ]);

      this.modelsLoaded = true;
      this.loading = false;
      this.progress = 100;
      this.notifyListeners();
      return Promise.resolve();
    } catch (err) {
      this.loading = false;
      this.progress = 0;
      this.notifyListeners();
      return Promise.reject(err);
    }
  }

  notifyListeners() {
    this.listeners.forEach(resolve => resolve());
    this.listeners = [];
  }

  getProgress() {
    return this.progress;
  }

  isLoaded() {
    return this.modelsLoaded;
  }

  isLoading() {
    return this.loading;
  }
}

// Exporta como Singleton
export default new FaceApiLoader();